<script>
import 'vue-select/dist/vue-select.css'
import Multiselect from 'vue-multiselect'
import { axiosGetPost } from '@router/axiosGetPost'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'StatusRq',
  props: {
    requestId: { type: [String, Number], default: null },
    mode: { type: String, default: null },
  },
  data() {
    return {
      requestIdC: this.requestId,
      modeC: this.mode,
      loadingData: false,
      id: null,
      name: null,
      status: {},
      companyUser: '',
      statusArray: [],
      usernameLoad: null,
      modalErrorShow: false,
      modalErrorText: null,
      url: null,
    }
  },
  components: { Multiselect },
  created() {
    const urls = {
      fcl: 'requests',
      lcl: 'requestsLCL',
      inlands: 'inlands',
    }

    this.url = urls[this.modeC.toLowerCase()]
    this.fetchData()
  },
  validations: {
    status: { required },
  },
  methods: {
    validate_fields() {
      let response = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$toastr.e('Status is required')
        response = false
      }
      return response
    },
    fetchData() {
      this.loadingData = true
      axiosGetPost(
        'get',
        this.url + '/status/' + this.requestIdC,
        {},
        'Get data Status ' + this.modeC.toLowerCase()
      ).then((response) => {
        let data = response.data
        this.id = data.id
        this.status = data.status
        this.name = data.name
        this.companyUser = data.company_user
        this.statusArray = data.statusArray
        this.usernameLoad = data.usernameLoad
        this.validation = data.validation
        this.loadingData = false
        return response
      })
    },
    changeStatus() {
      this.loadingData = true
      this.modalErrorShow = false
      if (this.validate_fields()) {
        axiosGetPost(
          'post',
          this.url + '/status/' + this.id,
          {
            data: { status: this.status },
          },
          'Update Status ' + this.modeC.toLowerCase()
        ).then((response) => {
          console.log(response)
          let data = response.data
          if (response.success === true) {
            this.$emit(
              'update_table_row',
              data.id,
              data.status,
              data.usernameLoad,
              data.contract_id,
              data.locked_options
            )
            this.$toastr.s('Successful Status Change Request ID: ' + data.id)
            this.loadingData = false
          } else {
            this.$toastr.e('Error Status Change Request ' + response.error)
            this.modalErrorText = response.error
            this.modalErrorShow = true
          }
          // this.clearRequestStatus()
          return response
        })
      }
    },
  },
}
</script>

<template>
  <div>
    <div
      v-if="loadingData === true && modalErrorShow === false"
      class="row align-items-center justify-content-center"
      style="height: 300px"
    >
      <div class="col-12 col-md-8 text-center">
        <b-spinner
          label="Loading..."
          variant="primary"
          class="ml-3"
        ></b-spinner>
      </div>
    </div>

    <div v-else-if="modalErrorShow === true">
      <div
        class="row align-items-center justify-content-center"
        style="height: 300px"
      >
        <div class="col-12 col-md-8 text-center">
          <feather type="frown" class="icon-xxl icon-dual-info"></feather>
          <h6 class="text-muted">Error Change Status </h6>
          <h6 class="text-muted" style="color: Tomato"
            >// {{ modalErrorText }} //</h6
          >
        </div>
      </div>
    </div>

    <div v-else>
      <div class="form-group row">
        <div class="col-lg-10">
          <label for="NameMD" class="form-control-label">Name:</label>
          <b-form-input
            id="input-horizontal"
            :value="name"
            :disabled="true"
          ></b-form-input>
        </div>
        <div class="col-lg-2">
          <label for="number" class="form-control-label">ID:</label>
          <input
            class="form-control"
            type="text"
            :value="id"
            required="required"
            disabled
          />
        </div>
      </div>
      <div class="form-group row">
        <div class="col-lg-4">
          <label for="number" class="form-control-label">Company User:</label>
          <input
            class="form-control"
            type="text"
            :value="companyUser"
            required="required"
            disabled
          />
        </div>
        <div class="col-lg-4">
          <label for="number" class="form-control-label">Date:</label>
          <input
            class="form-control"
            type="text"
            :value="validation"
            required="required"
            disabled
          />
        </div>
        <div class="col-lg-4">
          <label for="number" class="form-control-label">Username Load:</label>
          <input
            class="form-control"
            type="text"
            name="number"
            :value="usernameLoad"
            required="required"
            disabled
          />
        </div>
      </div>
      <hr />
      <div class="form-group row">
        <div class="col-lg-3"></div>
        <div class="col-lg-6">
          <label for="default">Status</label>
          <multiselect
            v-model="status"
            :options="statusArray"
            placeholder="Select one"
            label="display_name"
            track-by="display_name"
          ></multiselect>
        </div>
      </div>
      <hr />
      <div class="form-group row">
        <div class="col-lg-4"></div>
        <div class="col-lg-4">
          <b-button
            variant="primary"
            class="form-control"
            @click="changeStatus"
          >
            Save
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>
